import AmplitudeAnalytics from '@services/amplitude';
import { useState } from 'react';

import { APButton } from '@components/atoms/APButton';
import { createSingularLink } from '@utils/Singular';

import { DownloadLinkProps } from './types';
export const DownloadLink = ({ action, className, paymentExternalId }: DownloadLinkProps) => {
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState(false);

  const urlToDownload = createSingularLink(paymentExternalId);

  const handleCopy = async () => {
    try {
      if (navigator.clipboard) {
        // Modern browsers
        await navigator.clipboard.writeText(urlToDownload);
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = urlToDownload;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
      setCopied(true);
      setError(false);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
      setError(true);
      setTimeout(() => setError(false), 2000);
    }
  };

  const handleRedirect = () => {
    window.location.href = urlToDownload;
  };

  const handleAction = () => {
    // ------------amp event -------------
    AmplitudeAnalytics.downloadAstroPayLinkCopied(paymentExternalId || '');
    // ------------amp event -------------

    if (action === 'copyLink') {
      handleCopy();
    } else if (action === 'openLink') {
      handleRedirect();
    }
  };

  return (
    <div className={className}>
      <APButton
        textKey={
          error
            ? 'AstroPayDownload.failedToCopyLink'
            : copied
              ? 'AstroPayDownload.copiedLink'
              : action === 'copyLink'
                ? 'AstroPayDownload.copyLinkButton'
                : 'AstroPayDownload.getTheApp'
        }
        icon={action === 'copyLink' ? 'copy' : 'arrowRightLine'}
        className={className}
        onClick={handleAction}
        variant={action === 'openLink' ? 'primary' : 'secondary'}
        fullWidth
      />
    </div>
  );
};
